/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import axiosInstance from '../../../../../../axios_instance';
import {
  IsAdminContext, NumberOfAchivementsContext, NumberOfStrengthPassionsContext, StrengthPassionsListContext, UserStrengthPassionsDataContext
} from '../../../../../../context';
import { Row, Skeleton } from 'antd';
import { useParams } from 'react-router-dom';
import { reorder } from '../../../../../../utils/helper';
import swal from "sweetalert";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import StrengthPassionsDetails from './strength-passion-detail-view';
import AddStrengthPassions from './add-strength-passion';

//The parent component of core StrengthPassions's card
const StrengthPassionsCard: React.FC<any> = (): JSX.Element => {
  const [userStrengthPassionsData, setUserStrengthPassionsData] = useState<any>([]);
  const { numberOfStrengthPassions, setNumberOfStrengthPassions } = useContext(NumberOfStrengthPassionsContext);
  //state to store all StrengthPassions from database
  const [StrengthPassionsList, setStrengthPassionsList] = useState<any>();
  //state to enable add new content.If its true,add form will appear.
  const [addNew, setAddNew] = useState<boolean>(false);
  //context to check whether the logged in user is admin or normal user.
  const isAdmin = useContext(IsAdminContext);
  //this query parameter in URL will be available if the user is admin
  const { employeeId } = useParams();
  const [message, setMessage] = useState<string>()
  const [isLoading, setIsLoading] = useState<boolean>(true);

  //retrieve all StrengthPassions from database.User can select StrengthPassions from available StrengthPassions in this list.
  useEffect(() => {
    axiosInstance.get('/api/v1/profile/user-profiles/achievements').then((response) => {
      const allStrengthPassions = response.data.achievements.filter(
        (achievement: any) => achievement['status']['id'] === 1
      );
      const achievements = allStrengthPassions.reduce(
        (initialList: Object, CurrentList: { [key: string]: any }) => ({
          ...initialList,
          [CurrentList.achievement_name]: CurrentList.achievement_id,
        }),
        {}
      );
      setStrengthPassionsList(achievements);
    });
  }, []);

  //retrieve user's all StrengthPassions information.
  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/profile/admin/user-profiles/' + employeeId + '/strength_passions';
    } else {
      url = '/api/v1/profile/user-profiles/strength_passions';
    }
    axiosInstance.get(url).then((response) => {
      let userStrengthPassions: Array<any> = [];
      if (response.data.strength_passions.length !== 0) {
        userStrengthPassions = response.data.strength_passions.filter(
          (achievement: any) =>
            achievement['status']['id'] === 1
        );
        // const orderedStrengthPassions = response.data.order_achievements.map((achievementId: number) =>
        //   userStrengthPassions.find((userStrengthPassions: any) => userStrengthPassions.achievement_id === achievementId)
        // ).filter((item: any) => item !== undefined);
        setUserStrengthPassionsData(userStrengthPassions);
        // setUserStrengthPassionsData(userStrengthPassions);
      } else {
        setUserStrengthPassionsData(response.data.strength_passions);
      }
      setNumberOfStrengthPassions(userStrengthPassions.length);
    }).catch((error) => {
      console.log(error);
      setMessage("Something went wrong!Items couldn't be loaded!")
    }).finally(() => {
      setIsLoading(false)
    });
  }, []);

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    if (userStrengthPassionsData.length < 2) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    const items = reorder(
      userStrengthPassionsData,
      result.source.index,
      result.destination.index
    );
    const order_list = items.map((item: any) =>
      item.strength_passion_id || item.achievement_id
    );
    setUserStrengthPassionsData(
      items
    );

    const payload: any = {
      type: "strength_passions",
      updated_reorder_list: order_list
    };
    if (isAdmin === '1') {
      payload.profile_id = employeeId;
    }

    axiosInstance.post("/api/v1/reorder", payload).then((response) => {
      swal({
        title: 'Updated',
        text: 'Order of strength and passion has been updated',
        icon: "success",
      }).then((willRefresh) => {
        console.log()
      });
    }).catch((error) => {
      swal({
        title: 'Failed',
        text: 'Order of strength and passion could not be updated',
        icon: "error",
      }).then((willRefresh) => {
        console.log()
      });
    })
  }

  return (
    <div style={{ position: 'relative' }}>
      <UserStrengthPassionsDataContext.Provider
        value={{ userStrengthPassionsData, setUserStrengthPassionsData }}
      >
        <StrengthPassionsListContext.Provider value={{ ...StrengthPassionsList }}>
          {isLoading ? <Skeleton active /> : <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided: any, snapshot: any) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {userStrengthPassionsData && userStrengthPassionsData.map((item: any, index: any) => (
                    <Draggable key={`row_${item.StrengthPassions_id}`} draggableId={`row_${item.StrengthPassions_id}`} index={index}>
                      {(provided: any, snapshot: any) => (
                        <div

                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <StrengthPassionsDetails

                            key={index}
                            {...item}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>}
          {message ? <p style={{ color: "red" }}>{message}</p> : <></>}
          {addNew ? <AddStrengthPassions {...{ setAddNew: setAddNew }} /> : <></>}

          <Row style={{ position: 'relative' }}>
            <p
              className={styles['add-new']}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onClick={(e) => {
                setAddNew(true);
              }}
            >
              Add New (+)
            </p>
          </Row>
        </StrengthPassionsListContext.Provider>
      </UserStrengthPassionsDataContext.Provider>
    </div>
  );
};

export default StrengthPassionsCard;
